export const shouldHandleAppShellNavigation = (pathname, publicUrl = process.env.PUBLIC_URL) =>
  publicUrl === '/pwa' || !/^\/pwa(?:\/|$)/.test(pathname);

export const serviceWorkerUrl = (publicUrl, buildId) =>
  `${publicUrl}/service-worker.js${/^[\da-f]{64}$/.test(buildId || '') ? `?build=${buildId}` : ''}`;

const buildPattern = /^[\da-f]{64}$/;

// URL du fichier de version publié par build:prod. Le paramètre unique rend chaque lecture
// introuvable dans le cache du CDN, qui garde sinon d'anciennes réponses malgré no-cache.
export const versionUrl = (publicUrl, now = Date.now()) => `${publicUrl}/version.json?t=${now}`;

// Empreinte du build en ligne si elle diffère de celle de l'application chargée, sinon null.
export const newerBuild = (currentBuild, payload) => {
  const deployed = payload && payload.build;
  if (!buildPattern.test(currentBuild || '') || !buildPattern.test(deployed || '')) return null;
  return deployed === currentBuild ? null : deployed;
};
